module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0056.jpg?v=a0d587cf";